import { defineMessages } from 'react-intl';

export default defineMessages({
  statusNotDone: {
    id: 'neptune.Summary.statusNotDone',
    defaultMessage: 'Item to do',
  },
  statusPending: {
    id: 'neptune.Summary.statusPending',
    defaultMessage: 'Item pending',
  },
  statusDone: {
    id: 'neptune.Summary.statusDone',
    defaultMessage: 'Item done',
  },
});
